const email1 = {
  id: 1,
  passage: `March 22, 2025

To Whom It May Concern,

I am writing to strongly recommend Emily Park for the Excellence in Leadership Award. As a Senior Project Manager at NextVision Technologies, I have had the pleasure of working <mark>closely</mark> with Emily over the past three years, and I can confidently say she is a <mark>highly</mark> <mark>deserving</mark> candidate for this recognition.

During her time with our organization, Emily has consistently demonstrated <mark>exceptional</mark> professionalism, dedication, and leadership. Her <mark>contributions</mark>, particularly in leading the "Orion Platform" development project, resulted in a 40% increase in team productivity and a highly successful product launch.

Emily <mark>exemplifies</mark> the values and excellence that the Excellence in Leadership Award represents, and I believe she will continue to inspire and lead with <mark>integrity</mark> in all her future <mark>endeavors</mark>.

Please feel free to contact me if you need any additional information.

Sincerely,

Jason Liu 
Senior Director
NextVision Technologies`,

  translation: `2025년 3월 22일

관계자님께,

저는 Emily Park를 Excellence in Leadership Award에 강력히 추천하기 위해 이 글을 씁니다. NextVision Technologies의 Senior Project Manager로서, 저는 지난 3년 동안 Emily와 긴밀히 협력해 왔으며, 그녀가 이 상을 받기에 매우 적합한 후보라고 자신 있게 말할 수 있습니다.

우리 조직에서 근무하는 동안, Emily는 지속적으로 탁월한 전문성, 헌신, 그리고 리더십을 보여주었습니다. 특히 "Orion Platform" 개발 프로젝트를 이끌면서 그녀의 기여는 팀 생산성을 40% 향상시키고 매우 성공적인 제품 출시로 이어졌습니다.

Emily는 Excellence in Leadership Award가 대표하는 가치와 우수성을 구현하고 있으며, 앞으로도 모든 미래 활동에서 진실성을 가지고 영감을 주고 이끌어 나갈 것이라고 믿습니다.

추가 정보가 필요하시면 언제든지 연락해 주십시오.

감사합니다,

Jason Liu
Senior Director
NextVision Technologies`,

  koreanNouns: `March 22, 2025

To Whom It May Concern,

I am writing to strongly recommend Emily Park for the Excellence in Leadership Award. As a Senior Project Manager at NextVision Technologies, I have had the pleasure of working <mark>긴밀히</mark> with Emily over the past three years, and I can confidently say she is a <mark>매우</mark> <mark>자격이 있는</mark> candidate for this recognition.

During her time with our organization, Emily has consistently demonstrated <mark>탁월한</mark> professionalism, dedication, and leadership. Her <mark>기여</mark>, particularly in leading the "Orion Platform" development project, resulted in a 40% increase in team productivity and a highly successful product launch.

Emily <mark>모범이 되다</mark> the values and excellence that the Excellence in Leadership Award represents, and I believe she will continue to inspire and lead with <mark>진실성</mark> in all her future <mark>활동</mark>.

Please feel free to contact me if you need any additional information.

Sincerely,

Jason Liu 
Senior Director
NextVision Technologies`,

  wordPairs: {
    closely: "긴밀히",
    highly: "매우",
    deserving: "자격이 있는",
    exceptional: "탁월한",
    contributions: "기여",
    exemplifies: "모범이 되다",
    integrity: "진실성",
    endeavors: "활동",
  },

  questions: [],
};
const email2 = {
  id: 2,
  passage: `Subject: Upcoming Workshop Training – "Effective Project Management"

Dear David Johnson,

I am writing to inform you about an upcoming workshop training that will be held on April 12, 2025, at Conference Room B, 3rd Floor, Main Office Building. This training aims to provide you with the necessary skills and knowledge to enhance your performance and excel in your role within the company.

The workshop will <mark>cover</mark> various topics including but not limited to:
Setting realistic project timelines
Effective resource allocation
Managing project risks and <mark>contingencies</mark>

We have carefully designed this training to be engaging, <mark>interactive</mark>, and <mark>practical</mark>. You will have the opportunity to learn from industry experts, engage in group discussions, and participate in hands-on activities. By the end of this training, you will have acquired new skills and strategies that will greatly contribute to your professional development.

Attending this workshop is <mark>mandatory</mark> for all employees in your department. Your presence and active participation are crucial for its success. We encourage you to come prepared, take notes, and actively engage in all workshop activities.

If you have any questions or concerns regarding the workshop, please do not hesitate to contact our training coordinator John Smith at john@email.com.

We believe that this workshop will bring <mark>immense</mark> value to your professional growth, and we look forward to seeing you there.

Best regards,
Kevin Clark
Training & Development Manager`,

  translation: `제목: 예정된 워크숍 교육 - "효과적인 프로젝트 관리"

David Johnson님께,

2025년 4월 12일에 본사 건물 3층 회의실 B에서 개최될 예정인 워크숍 교육에 대해 알려드립니다. 이 교육은 귀하가 회사 내에서 역할을 수행하고 탁월한 성과를 내는 데 필요한 기술과 지식을 제공하는 것을 목표로 합니다.

워크숍은 다음을 포함한 다양한 주제를 다룰 예정입니다:

현실적인 프로젝트 일정 설정

효과적인 자원 할당

프로젝트 위험 및 비상 계획 관리

저희는 이 교육이 흥미롭고, 상호작용적이며, 실용적이 되도록 신중하게 설계했습니다. 귀하는 업계 전문가로부터 배우고, 그룹 토론에 참여하며, 실습 활동에 참여할 기회를 갖게 될 것입니다. 이 교육이 끝날 때쯤이면, 귀하의 전문적 발전에 크게 기여할 새로운 기술과 전략을 습득하게 될 것입니다.

이 워크숍 참석은 귀하 부서의 모든 직원에게 필수입니다. 귀하의 참석과 적극적인 참여는 성공을 위해 매우 중요합니다. 준비를 갖추고, 메모를 하며, 모든 워크숍 활동에 적극적으로 참여하시기를 권장합니다.

워크숍에 관한 질문이나 우려 사항이 있으시면, 교육 코디네이터 John Smith(john@email.com)에게 연락하시기 바랍니다.

이 워크숍이 귀하의 전문적 성장에 큰 가치를 가져다 줄 것이라 믿으며, 그곳에서 귀하를 뵙기를 기대합니다.

감사합니다,
Kevin Clark
교육 및 개발 매니저`,

  koreanNouns: `Subject: Upcoming Workshop Training – "Effective Project Management"

Dear David Johnson,

I am writing to inform you about an upcoming workshop training that will be held on April 12, 2025, at Conference Room B, 3rd Floor, Main Office Building. This training aims to provide you with the necessary skills and knowledge to enhance your performance and excel in your role within the company.

The workshop will <mark>다루다</mark> various topics including but not limited to:
Setting realistic project timelines
Effective resource allocation
Managing project risks and <mark>비상 계획</mark>

We have carefully designed this training to be engaging, <mark>상호작용적</mark>, and <mark>실용적</mark>. You will have the opportunity to learn from industry experts, engage in group discussions, and participate in hands-on activities. By the end of this training, you will have acquired new skills and strategies that will greatly contribute to your professional development.

Attending this workshop is <mark>필수</mark> for all employees in your department. Your presence and active participation are crucial for its success. We encourage you to come prepared, take notes, and actively engage in all workshop activities.

If you have any questions or concerns regarding the workshop, please do not hesitate to contact our training coordinator John Smith at john@email.com.

We believe that this workshop will bring <mark>큰</mark> value to your professional growth, and we look forward to seeing you there.

Best regards,
Kevin Clark
Training & Development Manager`,

  wordPairs: {
    cover: "다루다",
    contingencies: "비상 계획",
    interactive: "상호작용적",
    practical: "실용적",
    mandatory: "필수",
    immense: "큰",
  },

  questions: [],
};

const email3 = {
  id: 3,
  passage: `Subject: Invitation to Annual Charity Gala

Dear Susann Lopiccolo,

We are delighted to invite you to our <mark>Annual Charity Gala</mark>, which will be held on June 10, 2050, at Charles Hotel, starting at 3:00 PM. This <mark>prestigious</mark> event aims to bring distinguished guests together to support a noble cause and significantly impact our community.

The evening will feature a cocktail reception, a <mark>gourmet</mark> dinner, live entertainment, and a <mark>silent auction</mark> with <mark>exclusive</mark> items. We have <mark>curated</mark> an exceptional program to ensure our guests have an unforgettable experience while contributing to a worthy cause.

Please <mark>RSVP</mark> by June 08, 2050, to confirm your attendance. You can contact Liam Cho at liam.cho@civicimpact.org. Please let us know if you have any <mark>dietary</mark> restrictions or special requirements, and we will happily <mark>accommodate</mark> you.

We look forward to your presence at our Annual Charity Gala. Together, we can make a difference.

Warm regards,

Event Organizer

Civic Impact Foundation`,

  translation: `제목: 연례 자선 갈라 초대장

친애하는 Susann Lopiccolo님,

2050년 6월 10일 오후 3시부터 Charles Hotel에서 개최되는 연례 자선 갈라에 귀하를 초대하게 되어 기쁩니다. 이 명망 있는 행사는 고귀한 목적을 지원하고 우리 지역사회에 중요한 영향을 미치기 위해 저명한 손님들을 한자리에 모으는 것을 목표로 합니다.

이 저녁 행사는 칵테일 리셉션, 고급 만찬, 라이브 엔터테인먼트, 그리고 독점 아이템이 포함된 경매를 특징으로 합니다. 저희는 손님들이 가치 있는 목적에 기여하면서 잊지 못할 경험을 할 수 있도록 특별한 프로그램을 준비했습니다.

참석 여부를 확인하기 위해 2050년 6월 8일까지 회신해 주시기 바랍니다. Liam Cho(liam.cho@civicimpact.org)에게 연락하실 수 있습니다. 식이 제한이나 특별한 요구 사항이 있으시면 알려주시기 바랍니다. 기꺼이 도와드리겠습니다.

연례 자선 갈라에서 귀하의 참석을 기대합니다. 함께라면 우리는 변화를 만들 수 있습니다.

따뜻한 인사를 전합니다,

행사 주최자

Civic Impact Foundation`,

  koreanNouns: `Subject: Invitation to Annual Charity Gala

  Dear Susann Lopiccolo,
  
  We are delighted to invite you to our <mark>연례 자선 갈라</mark>, which will be held on June 10, 2050, at Charles Hotel, starting at 3:00 PM. This <mark>명망 있는</mark> event aims to bring distinguished guests together to support a noble cause and significantly impact our community.
  
  The evening will feature a cocktail reception, a <mark>고급</mark> dinner, live entertainment, and a <mark>경매</mark> with <mark>독점</mark> items. We have <mark>엄선했다</mark> an exceptional program to ensure our guests have an unforgettable experience while contributing to a worthy cause.
  
  Please <mark>회신해 주시기 바랍니다</mark> by June 08, 2050, to confirm your attendance. You can contact Liam Cho at liam.cho@civicimpact.org. Please let us know if you have any <mark>식이</mark> restrictions or special requirements, and we will happily <mark>맞춰주다</mark> you.
  
  We look forward to your presence at our Annual Charity Gala. Together, we can make a difference.
  
  Warm regards,
  
  Event Organizer
  
  Civic Impact Foundation`,

  wordPairs: {
    "Annual Charity Gala": "연례 자선 갈라",
    prestigious: "명망 있는",
    gourmet: "고급",
    "silent auction": "경매",
    exclusive: "독점",
    curated: "엄선했다",
    RSVP: "회신해 주시기 바랍니다",
    dietary: "식이",
    accommodate: "맞춰주다",
  },

  questions: [],
};
const email4 = {
  id: 4,
  passage: `Subject: Invitation to Altura Dynamics Inc. <mark>Corporate Event</mark>

Dear Mr. James Anderson,

We are pleased to cordially invite you to our upcoming <mark>corporate event</mark> organized by Altura Dynamics Inc. It is our honor to host this special event, which promises to be both insightful and engaging.

Event Details:

- Date: October 12, 2060
- Time: 10:00 AM – 4:00 PM
- Venue: Grand Hall, Skyline Convention Center, New York, NY 10001

The event agenda will include keynote presentations from industry experts, dynamic networking sessions, and opportunities to engage with thought leaders across various sectors. We will also be <mark>unveiling</mark> our latest innovations and strategic plans for the coming year, bringing together stakeholders, partners, and team members for a meaningful and productive experience.

We believe your attendance and participation will greatly contribute to the success of this event. Please confirm your participation by October 1, 2060, to ensure we make the necessary arrangements for your <mark>presence</mark>.

Kindly RSVP to Chloe Ramirez or email chloe.r@alturadyn.com at your earliest convenience. Should you have any questions or require further information, please feel free to reach out.

We look forward to your positive response and hope to see you at the event.

Sincerely,

Chloe Ramirez

Corporate Events Manager

Altura Dynamics Inc.`,

  translation: `제목: Altura Dynamics Inc. 기업 행사 초대장

친애하는 James Anderson님,

Altura Dynamics Inc.에서 주최하는 다가오는 기업 행사에 정중히 귀하를 초대하게 되어 기쁩니다. 통찰력 있고 매력적인 시간이 될 것을 약속하는 이 특별한 행사를 주최하게 되어 영광입니다.

행사 세부 정보:

- 날짜: 2060년 10월 12일
- 시간: 오전 10시 - 오후 4시
- 장소: Grand Hall, Skyline Convention Center, New York, NY 10001

행사 일정에는 업계 전문가들의 기조 발표, 역동적인 네트워킹 세션, 그리고 다양한 분야의 사상 리더들과 교류할 수 있는 기회가 포함됩니다. 또한 내년을 위한 최신 혁신과 전략적 계획을 공개하여 이해관계자, 파트너, 팀원들이 의미 있고 생산적인 경험을 위해 함께 모일 것입니다.

귀하의 참석과 참여가 이 행사의 성공에 크게 기여할 것이라고 믿습니다. 귀하의 참석을 위한 필요한 준비를 할 수 있도록 2060년 10월 1일까지 참가 여부를 확인해 주시기 바랍니다.

가능한 빠른 시일 내에 Chloe Ramirez에게 회신하거나 chloe.r@alturadyn.com으로 이메일을 보내주시기 바랍니다. 질문이 있거나 추가 정보가 필요하시면 언제든지 연락해 주십시오.

귀하의 긍정적인 답변을 기대하며 행사에서 뵙기를 희망합니다.

감사합니다,

Chloe Ramirez

기업 행사 매니저

Altura Dynamics Inc.`,

  koreanNouns: `Subject: Invitation to Altura Dynamics Inc. <mark>기업 행사</mark>

Dear Mr. James Anderson,

We are pleased to cordially invite you to our upcoming <mark>기업 행사</mark> organized by Altura Dynamics Inc. It is our honor to host this special event, which promises to be both insightful and engaging.

Event Details:

- Date: October 12, 2060
- Time: 10:00 AM – 4:00 PM
- Venue: Grand Hall, Skyline Convention Center, New York, NY 10001

The event agenda will include keynote presentations from industry experts, dynamic networking sessions, and opportunities to engage with thought leaders across various sectors. We will also be <mark>공개</mark> our latest innovations and strategic plans for the coming year, bringing together stakeholders, partners, and team members for a meaningful and productive experience.

We believe your attendance and participation will greatly contribute to the success of this event. Please confirm your participation by October 1, 2060, to ensure we make the necessary arrangements for your <mark>참석</mark>.

Kindly RSVP to Chloe Ramirez or email chloe.r@alturadyn.com at your earliest convenience. Should you have any questions or require further information, please feel free to reach out.

We look forward to your positive response and hope to see you at the event.

Sincerely,

Chloe Ramirez

Corporate Events Manager

Altura Dynamics Inc.`,

  wordPairs: {
    "corporate event": "기업 행사",
    unveiling: "공개",
    presence: "참석",
  },

  questions: [],
};
const email5 = {
  id: 5,
  passage: `Subject: Invitation to Hope for Tomorrow Foundation <mark>Fundraising</mark> Event

Dear Sponsor,

We are excited to announce our upcoming <mark>fundraising</mark> event, which will take place on October 15, 2050, at the Grand Ballroom of the City Hotel. This event aims to <mark>raise</mark> much-needed funds for the Hope for Tomorrow Foundation, an initiative <mark>dedicated to</mark> providing educational opportunities and resources for <mark>underprivileged</mark> children.

Your support and <mark>generosity</mark> play a crucial role in helping us achieve our mission. The <mark>contributions</mark> we receive from <mark>kind-hearted</mark> individuals like yourself enable us to continue our <mark>vital</mark> work and make a significant impact on the community. Whether it's through advancing our educational programs, providing essential resources, or supporting students in need, your donation makes a difference.

We <mark>cordially</mark> invite you to join us for an evening of fine dining, live entertainment, and inspiring speeches. It will be a wonderful opportunity to learn more about our efforts, connect with other supporters, and see <mark>firsthand</mark> the impact of your <mark>contributions</mark>.

If you are unable to attend but still wish to contribute, we <mark>warmly</mark> welcome donations of any size. Every little bit helps, and your <mark>generosity</mark> ensures that we can continue to make a positive difference.

Please RSVP by October 5, 2050, to ensure we can accommodate all our guests. For more information or to donate, please visit our website (www.hopefortomorrow.org) or contact our coordinator, Olivia Grant, at olivia@hopefortomorrow.org.

Thank you for your consideration and <mark>unwavering</mark> support. Together, we can make a meaningful difference.

Warm regards,

Olivia Grant

Community Outreach Coordinator`,

  translation: `제목: 내일의 희망 재단 기금 모금 행사 초대장

친애하는 후원자님,

2050년 10월 15일, 시티 호텔 그랜드 볼룸에서 개최될 예정인 저희 기금 모금 행사를 알려드리게 되어 기쁩니다. 이 행사는 소외된 아이들에게 교육 기회와 자원을 제공하는 데 헌신하는 '내일의 희망 재단'을 위한 필요한 기금을 모으는 것을 목표로 합니다.

귀하의 지원과 관대함은 저희가 사명을 달성하는 데 중요한 역할을 합니다. 귀하와 같은 따뜻한 마음을 가진 개인들로부터 받는 기부금은 저희가 중요한 활동을 계속하고 지역 사회에 큰 영향을 미칠 수 있게 합니다. 교육 프로그램 발전, 필수 자원 제공, 또는 도움이 필요한 학생 지원 등 어떤 형태로든, 귀하의 기부는 변화를 만듭니다.

저희는 귀하를 고급 식사, 라이브 엔터테인먼트, 그리고 영감을 주는 연설이 있는 저녁 시간에 초대합니다. 이는 저희의 노력에 대해 더 많이 배우고, 다른 후원자들과 연결하며, 귀하의 기부가 미치는 영향을 직접 볼 수 있는 좋은 기회가 될 것입니다.

참석이 어렵지만 여전히 기부하고 싶으시다면, 저희는 어떤 규모의 기부도 따뜻하게 환영합니다. 작은 도움도 큰 힘이 되며, 귀하의 관대함은 저희가 계속해서 긍정적인 변화를 만들 수 있도록 보장합니다.

모든 손님을 수용할 수 있도록 2050년 10월 5일까지 참석 여부를 알려주시기 바랍니다. 더 많은 정보나 기부를 원하시면, 저희 웹사이트(www.hopefortomorrow.org)를 방문하시거나 코디네이터 올리비아 그랜트에게 olivia@hopefortomorrow.org로 연락해 주십시오.

귀하의 고려와 변함없는 지원에 감사드립니다. 함께라면, 우리는 의미 있는 변화를 만들 수 있습니다.

따뜻한 인사를 전합니다,

올리비아 그랜트

커뮤니티 아웃리치 코디네이터`,
  koreanNouns: `Subject: Invitation to Hope for Tomorrow Foundation <mark>기금 모금</mark> Event

Dear Sponsor,

We are excited to announce our upcoming <mark>기금 모금</mark> event, which will take place on October 15, 2050, at the Grand Ballroom of the City Hotel. This event aims to <mark>모으는</mark> much-needed funds for the Hope for Tomorrow Foundation, an initiative <mark>헌신하는</mark> providing educational opportunities and resources for <mark>소외된</mark> children.

Your support and <mark>관대함</mark> play a crucial role in helping us achieve our mission. The <mark>기부금</mark> we receive from <mark>따뜻한 마음을 가진</mark> individuals like yourself enable us to continue our <mark>중요한</mark> work and make a significant impact on the community. Whether it's through advancing our educational programs, providing essential resources, or supporting students in need, your donation makes a difference.

We <mark>정중히</mark> invite you to join us for an evening of fine dining, live entertainment, and inspiring speeches. It will be a wonderful opportunity to learn more about our efforts, connect with other supporters, and see <mark>직접</mark> the impact of your <mark>기부금</mark>.

If you are unable to attend but still wish to contribute, we <mark>따뜻하게</mark> welcome donations of any size. Every little bit helps, and your <mark>관대함</mark> ensures that we can continue to make a positive difference.

Please RSVP by October 5, 2050, to ensure we can accommodate all our guests. For more information or to donate, please visit our website (www.hopefortomorrow.org) or contact our coordinator, Olivia Grant, at olivia@hopefortomorrow.org.

Thank you for your consideration and <mark>변함없는</mark> support. Together, we can make a meaningful difference.

Warm regards,

Olivia Grant

Community Outreach Coordinator`,

  wordPairs: {
    fundraising: "기금 모금",
    raise: "모으는",
    "dedicated to": "헌신하는",
    underprivileged: "소외된",
    generosity: "관대함",
    contributions: "기부금",
    "kind-hearted": "따뜻한 마음을 가진",
    vital: "중요한",
    cordially: "정중히",
    firsthand: "직접",
    warmly: "따뜻하게",
    unwavering: "변함없는",
  },

  questions: [],
};
const email6 = {
  id: 6,
  passage: `Dear Antonette,

I hope this letter finds you in great spirits. As the Director of Community <mark>Outreach</mark> at Brighter Futures Initiative, I am reaching out to share the exciting progress we have made in our mission to provide educational resources to <mark>underserved</mark> communities.

With your generous support in the past, we have been able to launch after-school programs that serve over 200 children in our local area. However, our journey is <mark>far from over</mark>, and we need your continued partnership to ensure we can expand our impact.

This year, we are aiming to raise $50,000 to fund our next project, which will create a mobile library that delivers books and learning materials to <mark>rural</mark> neighborhoods. Your contribution will make a significant difference, allowing us to reach more individuals and create lasting change in our community. We believe that together we can transform lives and <mark>empower</mark> those in need.

I invite you to join us in this vital mission by making a donation today. Every dollar counts and brings us closer to our goal. Please consider contributing through our website at www.brighterfutures.org or by contacting me directly at maya.kim@brighterfutures.org. Your support can truly change lives and help us build a brighter future for our community.

Thank you for your <mark>unwavering</mark> support and dedication to our cause. I look forward to your response and hope we can count on you once again as a vital partner in our mission.

Warm regards,

Maya Kim

Director of Community Outreach

Brighter Futures Initiative`,
  translation: `친애하는 Antonette님,

이 편지가 귀하께 좋은 기운과 함께 전달되기를 바랍니다. Brighter Futures Initiative의 커뮤니티 아웃리치 디렉터로서, 저는 소외된 지역사회에 교육 자원을 제공하는 우리의 사명에서 이룬 흥미로운 진전을 공유하고자 연락드립니다.

귀하의 과거 관대한 지원 덕분에, 우리는 지역 내 200명 이상의 아이들에게 방과 후 프로그램을 시작할 수 있었습니다. 하지만, 우리의 여정은 아직 끝나지 않았으며, 우리의 영향력을 확장하기 위해 귀하의 지속적인 파트너십이 필요합니다.

올해, 우리는 농촌 지역에 책과 학습 자료를 전달하는 이동 도서관을 만들기 위한 다음 프로젝트에 자금을 지원하기 위해 $50,000를 모금하는 것을 목표로 하고 있습니다. 귀하의 기부는 더 많은 개인에게 다가가고 우리 지역사회에 지속적인 변화를 만드는 데 중요한 차이를 만들 것입니다. 우리는 함께 삶을 변화시키고 도움이 필요한 이들에게 힘을 실어줄 수 있다고 믿습니다.

오늘 기부를 통해 이 중요한 사명에 동참해 주시기를 초대합니다. 모든 달러가 중요하며 우리를 목표에 더 가깝게 만듭니다. www.brighterfutures.org 웹사이트를 통해 또는 maya.kim@brighterfutures.org로 직접 연락하여 기부를 고려해 주시기 바랍니다. 귀하의 지원은 진정으로 삶을 변화시키고 우리 지역사회를 위한 더 밝은 미래를 구축하는 데 도움이 될 수 있습니다.

귀하의 변함없는 지원과 우리의 대의에 대한 헌신에 감사드립니다. 귀하의 응답을 기대하며 우리의 사명에서 중요한 파트너로서 다시 한번 귀하를 의지할 수 있기를 바랍니다.

따뜻한 인사를 전합니다,

Maya Kim

커뮤니티 아웃리치 디렉터

Brighter Futures Initiative`,
  koreanNouns: `Dear Antonette,

I hope this letter finds you in great spirits. As the Director of Community <mark>지원 활동</mark> at Brighter Futures Initiative, I am reaching out to share the exciting progress we have made in our mission to provide educational resources to <mark>소외된</mark> communities.

With your generous support in the past, we have been able to launch after-school programs that serve over 200 children in our local area. However, our journey is <mark>아직 끝나지 않았다</mark>, and we need your continued partnership to ensure we can expand our impact.

This year, we are aiming to raise $50,000 to fund our next project, which will create a mobile library that delivers books and learning materials to <mark>농촌</mark> neighborhoods. Your contribution will make a significant difference, allowing us to reach more individuals and create lasting change in our community. We believe that together we can transform lives and <mark>힘을 실어주다</mark> those in need.

I invite you to join us in this vital mission by making a donation today. Every dollar counts and brings us closer to our goal. Please consider contributing through our website at www.brighterfutures.org or by contacting me directly at maya.kim@brighterfutures.org. Your support can truly change lives and help us build a brighter future for our community.

Thank you for your <mark>변함없는</mark> support and dedication to our cause. I look forward to your response and hope we can count on you once again as a vital partner in our mission.

Warm regards,

Maya Kim

Director of Community Outreach

Brighter Futures Initiative`,
  wordPairs: {
    outreach: "지원 활동",
    underserved: "소외된",
    "far from over": "아직 끝나지 않았다",
    rural: "농촌",
    empower: "힘을 실어주다",
    unwavering: "변함없는",
  },
  questions: [],
};
const email7 = {
  id: 7,
  passage: `Dear Participants,

We are pleased to announce an upcoming workshop designed to enhance your skills and knowledge in your <mark>respective</mark> fields. 
This workshop promises to be an engaging and informative experience for all <mark>attendees</mark>.

Workshop Details
The workshop will be held on the following date and time:

Date: April 10, 2025
Time: 9:30 AM – 4:00 PM
Location: Grandview Conference Center, Room 204, 1210 Oak Lane, Seattle, WA

Highlights of the Workshop
The workshop will feature a variety of sessions that include:
Expert-led presentations by leadership consultants
Interactive group activities focused on real-world challenges
Hands-on learning opportunities using case studies
Networking sessions with peers and industry professionals

Registration Information
Please ensure you register by April 3, 2025 to <mark>secure</mark> your spot. Seats are limited and will be allocated on a <mark>first-come, first-served</mark> basis.

To register, please visit our website or contact us directly at:
Email: events@visionworkshops.org
Phone: (888) 456-9021

We look forward to your participation in making this workshop a successful and enriching experience for all.

Best regards,
Vision Workshops Team`,
  translation: `친애하는 참가자 여러분,

여러분의 각 분야에서 기술과 지식을 향상시키기 위해 설계된 워크숍을 개최하게 되어 기쁘게 생각합니다. 이 워크숍은 모든 참석자들에게 흥미롭고 유익한 경험이 될 것입니다.

워크숍 세부 정보
워크숍은 다음 날짜와 시간에 개최됩니다:

날짜: 2025년 4월 10일
시간: 오전 9:30 – 오후 4:00
장소: Grandview 컨퍼런스 센터, 204호실, 1210 Oak Lane, Seattle, WA

워크숍 하이라이트
워크숍은 다음을 포함한 다양한 세션으로 구성됩니다:

리더십 컨설턴트의 전문가 주도 프레젠테이션

실제 문제에 초점을 맞춘 상호작용적 그룹 활동

사례 연구를 활용한 실습 학습 기회

동료 및 업계 전문가와의 네트워킹 세션

등록 정보
2025년 4월 3일까지 등록하여 자리를 확보하시기 바랍니다. 좌석은 제한되어 있으며 선착순으로 배정됩니다.

등록하시려면 저희 웹사이트를 방문하시거나 다음 연락처로 직접 문의하시기 바랍니다:

이메일: events@visionworkshops.org
전화: (888) 456-9021

여러분의 참여로 이 워크숍이 모두에게 성공적이고 풍요로운 경험이 되기를 기대합니다.

감사합니다,
Vision Workshops 팀`,
  koreanNouns: `Dear Participants,

We are pleased to announce an upcoming workshop designed to enhance your skills and knowledge in your <mark>각자의</mark> fields. 
This workshop promises to be an engaging and informative experience for all <mark>참석자들</mark>.

Workshop Details
The workshop will be held on the following date and time:

Date: April 10, 2025
Time: 9:30 AM – 4:00 PM
Location: Grandview Conference Center, Room 204, 1210 Oak Lane, Seattle, WA

Highlights of the Workshop
The workshop will feature a variety of sessions that include:
Expert-led presentations by leadership consultants
Interactive group activities focused on real-world challenges
Hands-on learning opportunities using case studies
Networking sessions with peers and industry professionals

Registration Information
Please ensure you register by April 3, 2025 to <mark>확보하다</mark> your spot. Seats are limited and will be allocated on a <mark>선착순</mark> basis.

To register, please visit our website or contact us directly at:
Email: events@visionworkshops.org
Phone: (888) 456-9021

We look forward to your participation in making this workshop a successful and enriching experience for all.

Best regards,
Vision Workshops Team`,
  wordPairs: {
    respective: "각자의",
    attendees: "참석자들",
    secure: "확보하다",
    "first-come, first-served": "선착순",
  },
  questions: [],
};
const email8 = {
  id: 8,
  passage: `Dear Dr. Eleanor Grant,

I hope this message finds you well. My name is Daniel Yoon, and I am the coordinator of the upcoming Science and Technology Forum 2025, an event dedicated to exploring the latest advancements and trends in the field of technology and innovation.

We have been following your work with great interest, especially your contributions to AI-driven healthcare diagnostics, particularly your recent publication "Transforming Diagnosis: Machine Learning in Clinical Practice." Your expertise and insights would be invaluable to the participants of our forum.

Details of the Event
Date: May 16, 2025
Time: 10:00 AM – 4:30 PM
Venue: Innovation Hall, Stanford University, Palo Alto, CA
Audience: Industry professionals, academics, and students passionate about science and technology

We would be honored if you could join us as a keynote speaker. Your presentation on "The Future of Artificial Intelligence in Healthcare Innovation" would greatly <mark>enrich</mark> the discussions and provide valuable knowledge to our audience.

Next Steps
If you are interested in participating, please let us know your availability, and we can arrange the necessary logistics at your convenience. We would be happy to cover any travel and accommodation expenses that may be <mark>incurred</mark>.

Thank you for considering our invitation. We look forward to the possibility of having you at our forum and <mark>benefiting</mark> from your expertise.

Warm regards,
Daniel Yoon
Event Coordinator
Science and Technology Forum 2025`,
  translation: `친애하는 Eleanor Grant 박사님께,

이 메시지가 귀하께 잘 전달되기를 바랍니다. 저는 Daniel Yoon이며, 기술과 혁신 분야의 최신 발전과 트렌드를 탐구하는 행사인 2025년 과학 기술 포럼의 코디네이터입니다.

저희는 귀하의 연구에 큰 관심을 가지고 지켜보았습니다. 특히 AI 기반 의료 진단에 대한 귀하의 기여, 특히 최근 발표하신 "진단의 변화: 임상 실무에서의 기계 학습"에 주목하고 있습니다. 귀하의 전문 지식과 통찰력은 저희 포럼 참가자들에게 매우 귀중할 것입니다.

행사 세부 정보
날짜: 2025년 5월 16일

시간: 오전 10시 – 오후 4시 30분

장소: 캘리포니아 팔로알토, 스탠포드 대학교, 이노베이션 홀

청중: 과학과 기술에 열정을 가진 업계 전문가, 학자, 학생들

귀하를 기조 연설자로 모시게 된다면 큰 영광일 것입니다. "의료 혁신에서의 인공지능의 미래"에 관한 귀하의 발표는 토론을 크게 풍요롭게 하고 청중들에게 귀중한 지식을 제공할 것입니다.

다음 단계
참여에 관심이 있으시다면, 귀하의 가능한 일정을 알려주시면 필요한 물류를 귀하의 편의에 맞게 준비할 수 있습니다. 발생할 수 있는 모든 여행 및 숙박 비용을 저희가 기꺼이 부담하겠습니다.

저희의 초대를 고려해 주셔서 감사합니다. 귀하를 저희 포럼에 모시고 귀하의 전문 지식을 통해 혜택을 받을 수 있기를 기대합니다.

따뜻한 인사를 전합니다,
Daniel Yoon
행사 코디네이터
2025년 과학 기술 포럼`,
  koreanNouns: `Dear Dr. Eleanor Grant,

I hope this message finds you well. My name is Daniel Yoon, and I am the coordinator of the upcoming Science and Technology Forum 2025, an event dedicated to exploring the latest advancements and trends in the field of technology and innovation.

We have been following your work with great interest, especially your contributions to AI-driven healthcare diagnostics, particularly your recent publication "Transforming Diagnosis: Machine Learning in Clinical Practice." Your expertise and insights would be invaluable to the participants of our forum.

Details of the Event
Date: May 16, 2025
Time: 10:00 AM – 4:30 PM
Venue: Innovation Hall, Stanford University, Palo Alto, CA
Audience: Industry professionals, academics, and students passionate about science and technology

We would be honored if you could join us as a keynote speaker. Your presentation on "The Future of Artificial Intelligence in Healthcare Innovation" would greatly <mark>풍요롭게 하다</mark> the discussions and provide valuable knowledge to our audience.

Next Steps
If you are interested in participating, please let us know your availability, and we can arrange the necessary logistics at your convenience. We would be happy to cover any travel and accommodation expenses that may be <mark>발생한</mark>.

Thank you for considering our invitation. We look forward to the possibility of having you at our forum and <mark>혜택을 받다</mark> from your expertise.

Warm regards,
Daniel Yoon
Event Coordinator
Science and Technology Forum 2025`,
  wordPairs: {
    enrich: "풍요롭게 하다",
    incurred: "발생한",
    benefiting: "혜택을 받다",
  },
  questions: [],
};
const email9 = {
  id: 9,
  passage: `Subject: Annual In-House Sports Day Event - Join Us!

Dear Team,

We are thrilled to announce our upcoming Annual In-House Sports Day Event, a full day dedicated to fun, fitness, and team spirit! This is the perfect chance to take a break from the daily routine, connect with colleagues, and enjoy some friendly competition in a relaxed setting.

Event Details
Date: Saturday, November 12, 2023
Time: 9:00 AM – 5:00 PM
Venue: Central City Sports Complex
123 Sports Avenue, OurCity

Whether you're a <mark>seasoned</mark> athlete or just in it for the laughs and memories, there's something for everyone!

What to Bring
To stay comfortable and energized throughout the day, we recommend bringing:
Sportswear appropriate for outdoor activity
Comfortable running or sports shoes
Personal water bottle
Towel and extra clothes for changing
Sunscreen or a cap if needed (some events will be held outdoors)

Sports & Activities
We've lined up an exciting mix of sports and <mark>lighthearted</mark> games to suit all interest levels:

Team Sports: Soccer, Basketball, Volleyball
Racquet Sports: Badminton
Track & Field Events: Sprint, Long Jump, Relay
Fun Games: Tug of war, Sack race, Balloon pop, Mystery relays

Don't worry if you're not super athletic—it's all about participation, laughter, and team bonding!

Meals & Transport
Lunch, snacks, and drinks will be provided throughout the day.

If you have any <mark>dietary</mark> restrictions or allergies, please inform HR by November 3.

<mark>Transportation</mark> to and from the <mark>venue</mark> will be arranged. Pick-up times and locations will be shared closer to the event date.

Let's Make It Count!
We encourage all team members to attend and help make this a truly energizing, <mark>inclusive</mark>, and unforgettable experience. Let's bring our departments together and build stronger connections—on and off the field.

See you there, ready to move and have fun!

Best regards,
The HR Team`,
  translation: `제목: 연례 사내 스포츠 데이 행사 - 함께해요!

친애하는 팀원 여러분,

즐거움, 건강, 그리고 팀 정신에 헌신하는 하루인 연례 사내 스포츠 데이 행사를 발표하게 되어 기쁩니다! 이는 일상적인 루틴에서 벗어나 동료들과 교류하고 편안한 환경에서 친선 경쟁을 즐길 수 있는 완벽한 기회입니다.

행사 세부 정보
날짜: 2023년 11월 12일 토요일
시간: 오전 9시 – 오후 5시
장소: 센트럴 시티 스포츠 컴플렉스
123 스포츠 애비뉴, 아워시티

베테랑 운동선수이든 웃음과 추억을 위해 참여하든, 모든 사람을 위한 무언가가 있습니다!

준비물
하루 종일 편안하고 활기차게 지내기 위해 다음을 지참하는 것을 권장합니다:
야외 활동에 적합한 스포츠웨어
편안한 러닝화 또는 스포츠화
개인 물병
수건 및 갈아입을 여분의 옷
필요한 경우 자외선 차단제 또는 모자 (일부 행사는 야외에서 진행됩니다)

스포츠 및 활동
모든 관심 수준에 맞는 흥미로운 스포츠와 가벼운 게임을 준비했습니다:

팀 스포츠: 축구, 농구, 배구
라켓 스포츠: 배드민턴
육상 경기: 단거리 달리기, 멀리뛰기, 릴레이
재미있는 게임: 줄다리기, 자루 경주, 풍선 터뜨리기, 미스터리 릴레이

운동을 잘 못해도 걱정하지 마세요—참여, 웃음, 그리고 팀 유대감이 중요합니다!

식사 및 교통
점심, 간식, 음료가 하루 종일 제공됩니다.

식이 제한이나 알레르기가 있으시면 11월 3일까지 HR에 알려주세요.

행사장까지의 교통편이 마련될 예정입니다. 픽업 시간과 장소는 행사 날짜에 가까워지면 공유될 예정입니다.

함께 만들어가요!
모든 팀원들이 참석하여 이 행사를 진정으로 활기차고, 포용적이며, 잊을 수 없는 경험으로 만들어 주시기를 권장합니다. 부서 간의 연결을 강화하고 경기장 안팎에서 더 강한 유대감을 형성합시다.

준비하고 즐길 준비를 하고 뵙겠습니다!

감사합니다,
HR 팀`,
  koreanNouns: `Subject: Annual In-House Sports Day Event - Join Us!

Dear Team,

We are thrilled to announce our upcoming Annual In-House Sports Day Event, a full day dedicated to fun, fitness, and team spirit! This is the perfect chance to take a break from the daily routine, connect with colleagues, and enjoy some friendly competition in a relaxed setting.

Event Details
Date: Saturday, November 12, 2023
Time: 9:00 AM – 5:00 PM
Venue: Central City Sports Complex
123 Sports Avenue, OurCity

Whether you're a <mark>숙련된</mark> athlete or just in it for the laughs and memories, there's something for everyone!

What to Bring
To stay comfortable and energized throughout the day, we recommend bringing:
Sportswear appropriate for outdoor activity
Comfortable running or sports shoes
Personal water bottle
Towel and extra clothes for changing
Sunscreen or a cap if needed (some events will be held outdoors)

Sports & Activities
We've lined up an exciting mix of sports and <mark>가볍고 유쾌한</mark> games to suit all interest levels:

Team Sports: Soccer, Basketball, Volleyball
Racquet Sports: Badminton
Track & Field Events: Sprint, Long Jump, Relay
Fun Games: Tug of war, Sack race, Balloon pop, Mystery relays

Don't worry if you're not super athletic—it's all about participation, laughter, and team bonding!

Meals & Transport
Lunch, snacks, and drinks will be provided throughout the day.

If you have any <mark>식이</mark> restrictions or allergies, please inform HR by November 3.

<mark>교통편</mark> to and from the <mark>행사장</mark> will be arranged. Pick-up times and locations will be shared closer to the event date.

Let's Make It Count!
We encourage all team members to attend and help make this a truly energizing, <mark>포용적인</mark>, and unforgettable experience. Let's bring our departments together and build stronger connections—on and off the field.

See you there, ready to move and have fun!

Best regards,
The HR Team`,
  wordPairs: {
    숙련된: "seasoned",
    "가볍고 유쾌한": "lighthearted",
    식이: "dietary",
    교통편: "Transportation",
    행사장: "venue",
    포용적인: "inclusive",
  },
  questions: [],
};
const email10 = {
  id: 10,
  passage: `Subject: Join Our One-Day Baking Class - Discover the Art of Pastry!

Dear Baking Enthusiast,

We are delighted to invite you to our upcoming One-Day Baking Class, where you can <mark>immerse</mark> yourself in the wonderful world of pastry making. This special event is designed for both beginners and those with some baking experience who wish to enhance their skills in a <mark>friendly</mark>, <mark>supportive</mark> environment.

Discover Our Baking One-Day Class

Welcome to an exciting journey into the world of baking! Our one-day class is designed for both beginners and experienced bakers who wish to <mark>refine</mark> their skills. Join us for an <mark>immersive</mark>, hands-on experience that will awaken your inner pastry chef.

What You Will Learn

Our one-day class covers a variety of essential baking skills and techniques. You will learn:

- How to prepare doughs and <mark>batters</mark> <mark>from scratch</mark>
- The secrets of perfect cake baking and decorating
- Techniques for making light and flaky pastries
- Tips for baking delicious breads

Class Details
The class is hosted in our fully equipped professional kitchen, where you will work <mark>alongside</mark> our skilled instructors. Each participant will have their own workstation to ensure a personal learning experience.

Duration
The class runs for approximately 6 hours, including a short break for <mark>refreshments</mark>.

Location
The class will be held at our main location: 123 Bakery Street, Sweetville. We are easily accessible by public transport and have <mark>ample</mark> parking space available.

Materials
All necessary materials and ingredients will be provided. Participants only need to bring their enthusiasm and creativity!

How to Enroll
Spaces are limited, so be sure to <mark>secure</mark> your spot soon. To enroll, click on the enrollment link on our website or call our team. Join us for a delightful day of baking and take home an array of delicious creations!

We look forward to baking with you!

Warm regards,
The Baking Academy Team`,
  translation: `제목: 원데이 베이킹 클래스에 참여하세요 - 제과의 예술을 발견하세요!

친애하는 베이킹 애호가님께,

다가오는 원데이 베이킹 클래스에 여러분을 초대하게 되어 기쁩니다. 이곳에서 여러분은 제과 만들기의 멋진 세계에 몰입할 수 있습니다. 이 특별한 이벤트는 초보자와 친절하고 지원적인 환경에서 기술을 향상시키고자 하는 약간의 베이킹 경험이 있는 분들 모두를 위해 설계되었습니다.

베이킹 원데이 클래스 소개

베이킹의 세계로 떠나는 흥미진진한 여정에 오신 것을 환영합니다! 저희 원데이 클래스는 초보자와 기술을 연마하고자 하는 경험 많은 제빵사 모두를 위해 설계되었습니다. 여러분의 내면의 제과 셰프를 일깨울 몰입형 체험에 참여해 보세요.

배우게 될 내용

저희 원데이 클래스는 다양한 필수 베이킹 기술과 테크닉을 다룹니다. 다음을 배우게 됩니다:

- 처음부터 반죽과 배터를 준비하는 방법
- 완벽한 케이크 베이킹과 장식의 비밀
- 가볍고 바삭한 페이스트리를 만드는 기술
- 맛있는 빵을 굽는 팁

클래스 세부 정보

클래스는 완벽하게 갖춰진 전문 주방에서 진행되며, 숙련된 강사들과 함께 작업하게 됩니다. 각 참가자는 개인적인 학습 경험을 보장하기 위해 자신만의 작업대를 갖게 됩니다.

소요 시간

클래스는 간식 시간을 포함하여 약 6시간 동안 진행됩니다.

위치

클래스는 저희 메인 위치인 123 Bakery Street, Sweetville에서 열립니다. 대중교통으로 쉽게 접근할 수 있으며 충분한 주차 공간이 마련되어 있습니다.

준비물

모든 필요한 재료와 도구는 제공됩니다. 참가자들은 열정과 창의력만 가져오시면 됩니다!

등록 방법

자리가 제한되어 있으니 빨리 자리를 확보하세요. 등록하려면 저희 웹사이트의 등록 링크를 클릭하거나 팀에 전화하세요. 즐거운 베이킹의 하루에 참여하고 맛있는 창작물을 집으로 가져가세요!

여러분과 함께 베이킹하기를 기대합니다!

감사합니다,
베이킹 아카데미 팀`,
  koreanNouns: `Subject: Join Our One-Day Baking Class - Discover the Art of Pastry!

Dear Baking Enthusiast,

We are delighted to invite you to our upcoming One-Day Baking Class, where you can <mark>몰입하다</mark> yourself in the wonderful world of pastry making. This special event is designed for both beginners and those with some baking experience who wish to enhance their skills in a <mark>친절한</mark>, <mark>지원적인</mark> environment.

Discover Our Baking One-Day Class

Welcome to an exciting journey into the world of baking! Our one-day class is designed for both beginners and experienced bakers who wish to <mark>연마하다</mark> their skills. Join us for an <mark>몰입형</mark>, hands-on experience that will awaken your inner pastry chef.

What You Will Learn

Our one-day class covers a variety of essential baking skills and techniques. You will learn:

- How to prepare doughs and <mark>반죽</mark> <mark>처음부터</mark>
- The secrets of perfect cake baking and decorating
- Techniques for making light and flaky pastries
- Tips for baking delicious breads

Class Details
The class is hosted in our fully equipped professional kitchen, where you will work <mark>함께</mark> our skilled instructors. Each participant will have their own workstation to ensure a personal learning experience.

Duration
The class runs for approximately 6 hours, including a short break for <mark>간식</mark>.

Location
The class will be held at our main location: 123 Bakery Street, Sweetville. We are easily accessible by public transport and have <mark>충분한</mark> parking space available.

Materials
All necessary materials and ingredients will be provided. Participants only need to bring their enthusiasm and creativity!

How to Enroll
Spaces are limited, so be sure to <mark>확보하다</mark> your spot soon. To enroll, click on the enrollment link on our website or call our team. Join us for a delightful day of baking and take home an array of delicious creations!

We look forward to baking with you!

Warm regards,
The Baking Academy Team`,
  wordPairs: {
    immerse: "몰입하다",
    friendly: "친절한",
    supportive: "지원적인",
    refine: "연마하다",
    immersive: "몰입형",
    batters: "반죽",
    "from scratch": "처음부터",
    alongside: "함께",
    refreshments: "간식",
    ample: "충분한",
    secure: "확보하다",
  },
  questions: [],
};
const email11 = {
  id: 11,
  passage: `Subject: Registration Now Open – 2025 Global Innovation Expo

Dear Valued Partner,

We are pleased to announce that registration is now open for the 2025 Global Innovation Expo, one of the largest international exhibitions for technology, <mark>sustainability</mark>, and future industry trends.

The expo will be held from June 12 to June 15, 2025, at the Metro International Exhibition Center in San Francisco, CA. This year's theme is "Innovate Together, Grow Beyond."

Participants will have the opportunity to:
Network with over 300 global companies and industry leaders
Attend keynote sessions, product demos, and workshops
Showcase their innovations in front of investors and media

If your company is interested in reserving a booth space, please complete the online application form no later than April 30, 2025. Early registrants will receive a 10% discount on exhibition fees.

Apply Here

For more information about booth <mark>specifications</mark>, event schedules, or sponsorship options, please contact us at expo@globalsummitexpo.com.

We look forward to your participation in making this event a great success.

Best regards,
Olivia Chen
Event Coordinator
Global Innovation Expo 2025`,
  translation: `제목: 등록 시작 – 2025 글로벌 혁신 엑스포

친애하는 파트너님께,

2025 글로벌 혁신 엑스포의 등록이 시작되었음을 알려드립니다. 이 행사는 기술, 지속가능성 및 미래 산업 트렌드를 위한 가장 큰 국제 전시회 중 하나입니다.

엑스포는 2025년 6월 12일부터 6월 15일까지 샌프란시스코 메트로 국제 전시 센터에서 개최됩니다. 올해의 주제는 "함께 혁신하고, 더 멀리 성장하자"입니다.

참가자들은 다음과 같은 기회를 갖게 됩니다:

300개 이상의 글로벌 기업 및 업계 리더들과 네트워킹

기조 연설, 제품 시연 및 워크숍 참석

투자자와 미디어 앞에서 자신의 혁신을 선보이기

귀사가 부스 공간 예약에 관심이 있으시다면, 2025년 4월 30일까지 온라인 신청서를 작성해 주십시오. 조기 등록자는 전시 비용의 10% 할인을 받게 됩니다.

여기에서 신청하기

부스 사양, 행사 일정 또는 후원 옵션에 대한 자세한 정보는 expo@globalsummitexpo.com으로 문의해 주십시오.

이 행사를 성공적으로 만드는 데 귀하의 참여를 기대합니다.

감사합니다,
올리비아 첸
행사 코디네이터
2025 글로벌 혁신 엑스포`,
  koreanNouns: `Subject: Registration Now Open – 2025 Global Innovation Expo

Dear Valued Partner,

We are pleased to announce that registration is now open for the 2025 Global Innovation Expo, one of the largest international exhibitions for technology, <mark>지속가능성</mark>, and future industry trends.

The expo will be held from June 12 to June 15, 2025, at the Metro International Exhibition Center in San Francisco, CA. This year's theme is "Innovate Together, Grow Beyond."

Participants will have the opportunity to:
Network with over 300 global companies and industry leaders
Attend keynote sessions, product demos, and workshops
Showcase their innovations in front of investors and media

If your company is interested in reserving a booth space, please complete the online application form no later than April 30, 2025. Early registrants will receive a 10% discount on exhibition fees.

Apply Here

For more information about booth <mark>사양</mark>, event schedules, or sponsorship options, please contact us at expo@globalsummitexpo.com.

We look forward to your participation in making this event a great success.

Best regards,
Olivia Chen
Event Coordinator
Global Innovation Expo 2025`,
  wordPairs: {
    sustainability: "지속가능성",
    specifications: "사양",
  },
  questions: [],
};
const email12 = {
  id: 12,
  passage: `Subject: Mandatory Workplace Safety Training

Dear Employees,

As part of our ongoing <mark>commitment</mark> to workplace safety, all employees are required to complete a mandatory safety training session. The training will be held as follows:

Date: Friday, April 5
Time: 10:00 AM – 12:00 PM
Location: Main Conference Hall
Attendance is <mark>compulsory</mark> for all staff members. Employees who are unable to attend must notify HR in advance and complete the training online.

If you have any questions, please contact training@company.com.

Best regards,
Jennifer Adams
Training Coordinator`,

  translation: `제목: 필수 직장 안전 교육

직원 여러분,

직장 안전에 대한 지속적인 노력의 일환으로, 모든 직원들은 필수 안전 교육 세션을 이수해야 합니다. 교육은 다음과 같이 진행됩니다:

날짜: 4월 5일 금요일
시간: 오전 10시 - 오후 12시
장소: 메인 컨퍼런스홀
모든 직원의 참석이 의무입니다. 참석이 불가능한 직원들은 인사팀에 사전 통보하고 온라인으로 교육을 이수해야 합니다.

문의사항이 있으시면 training@company.com으로 연락 주시기 바랍니다.

감사합니다.
Jennifer Adams
교육 코디네이터`,

  koreanNouns: `Subject: Mandatory Workplace Safety Training

Dear Employees,

As part of our ongoing <mark>노력</mark> to workplace safety, all employees are required to complete a mandatory safety training session. The training will be held as follows:

Date: Friday, April 5
Time: 10:00 AM – 12:00 PM
Location: Main Conference Hall
Attendance is <mark>의무</mark> for all staff members. Employees who are unable to attend must notify HR in advance and complete the training online.

If you have any questions, please contact training@company.com.

Best regards,
Jennifer Adams
Training Coordinator`,

  wordPairs: {
    commitment: "노력",
    compulsory: "의무",
  },

  questions: [],
};

const email13 = {
  id: 13,
  passage: `Subject: Request to Reschedule Project Review Meeting

Dear Mr. Anderson,

I hope this email finds you well. I am writing to inform you that we need to reschedule the Project Review Meeting originally set for Tuesday, March 12, at 3:00 PM due to an unexpected scheduling conflict.

Would you be available on Thursday, March 14, at 2:00 PM instead? If this time does not work for you, please let me know your availability, and I will adjust the schedule <mark>accordingly</mark>.

I apologize for any inconvenience this may cause and appreciate your <mark>flexibility</mark>. Please confirm the <mark>revised</mark> meeting schedule at your earliest convenience.

Best regards,
James Carter
Project Coordinator`,

  translation: `제목: 프로젝트 검토 회의 일정 변경 요청

Anderson님께,

안녕하십니까. 예기치 않은 일정 충돌로 인해 3월 12일 화요일 오후 3시로 예정되어 있던 프로젝트 검토 회의 일정을 변경해야 함을 알려드립니다.

대신 3월 14일 목요일 오후 2시에 가능하신지요? 만약 이 시간이 적절하지 않으시다면, 가능하신 시간을 알려주시면 그에 따라 일정을 조정하도록 하겠습니다.

불편을 끼쳐 죄송합니다. 양해해 주셔서 감사합니다. 변경된 회의 일정을 가능한 한 빨리 확인해 주시기 바랍니다.

감사합니다.
James Carter
프로젝트 코디네이터`,

  koreanNouns: `Subject: Request to Reschedule Project Review Meeting

Dear Mr. Anderson,

I hope this email finds you well. I am writing to inform you that we need to reschedule the Project Review Meeting originally set for Tuesday, March 12, at 3:00 PM due to an unexpected scheduling conflict.

Would you be available on Thursday, March 14, at 2:00 PM instead? If this time does not work for you, please let me know your availability, and I will adjust the schedule <mark>accordingly</mark>.

I apologize for any inconvenience this may cause and appreciate your <mark>flexibility</mark>. Please confirm the <mark>revised</mark> meeting schedule at your earliest convenience.

Best regards,
James Carter
Project Coordinator`,

  wordPairs: {
    accordingly: "그에 따라",
    flexibility: "양해",
    revised: "변경된",
  },

  questions: [],
};

const email14 = {
  id: 14,
  passage: `Subject: Invitation – Horizon Business Innovation Conference 2025
Dear Ms. Katherine Lee,

We are pleased to invite you to the Horizon Business Innovation Conference 2025, a premier event designed to bring together industry leaders, <mark>entrepreneurs</mark>, and professionals to explore the <mark>latest</mark> trends in business strategy, digital transformation, and leadership development.

Event Details:
✔ Date: April 25–26, 2025
✔ Location: Grand Summit Convention Center, San Francisco, CA
✔ Theme: "Innovate, Transform, Succeed – The Future of Business"


Keynote Speakers:
✔ Dr. Michael Roberts – CEO, Global Tech Solutions
✔ Ms. Emily Carter – <mark>Renowned</mark> Business Strategist & Author
✔ Mr. Jonathan Park – Chief Digital Officer, Horizon Innovations


Registration Information:
✔ Early Bird Discount: $250 (Register by March 31, 2025)
✔ Standard Registration Fee: $350 (After March 31, 2025)
✔ Group Discount: 10% off for groups of 5 or more

Register Now: Visit www.horizonconference2025.com to secure your spot.

Why Attend?
✔ Gain valuable insights from industry experts
✔ Participate in <mark>interactive</mark> workshops and panel discussions
✔ Expand your professional network with global business leaders

For any inquiries regarding the conference or registration, please contact our Event Coordinator, Lisa Adams, at events@horizoncompany.com.

We look forward to welcoming you to this exclusive event!

Best regards,
Daniel Roberts
Conference Director
Horizon Business Events`,

  translation: `제목: 초대장 - 2025 호라이즌 비즈니스 혁신 컨퍼런스
캐서린 리 님께,

산업 리더, 기업가 및 전문가들이 모여 비즈니스 전략, 디지털 전환, 리더십 개발의 최신 트렌드를 탐구하는 프리미어 이벤트인 2025 호라이즌 비즈니스 혁신 컨퍼런스에 귀하를 초대하게 되어 기쁩니다.

행사 세부사항:
✔ 일시: 2025년 4월 25일-26일
✔ 장소: 그랜드 서밋 컨벤션 센터, 샌프란시스코, CA
✔ 주제: "혁신, 변화, 성공 - 비즈니스의 미래"

기조연설자:
✔ 마이클 로버츠 박사 : 글로벌 테크 솔루션즈 CEO
✔ 에밀리 카터 : 저명한 비즈니스 전략가 및 작가
✔ 조나단 박 : 호라이즌 이노베이션즈 최고디지털책임자

등록 정보:
✔ 얼리버드 할인: $250 (2025년 3월 31일까지 등록)
✔ 일반 등록비: $350 (2025년 3월 31일 이후)
✔ 단체 할인: 5인 이상 그룹 10% 할인

 지금 등록하세요: www.horizonconference2025.com에서 자리를 확보하세요.

참석해야 하는 이유:
✔ 업계 전문가들로부터 귀중한 인사이트 획득
✔ 대화형 워크샵과 패널 토론 참여
✔ 글로벌 비즈니스 리더들과의 전문가 네트워크 확장

컨퍼런스나 등록에 관한 문의사항은 이벤트 코디네이터 리사 아담스(events@horizoncompany.com)에게 연락 주시기 바랍니다.

이 특별한 행사에서 귀하를 맞이하기를 기대합니다!

감사합니다.
대니얼 로버츠
컨퍼런스 디렉터
호라이즌 비즈니스 이벤츠`,

  koreanNouns: `Subject: Invitation – Horizon Business Innovation Conference 2025
Dear Ms. Katherine Lee,

We are pleased to invite you to the Horizon Business Innovation Conference 2025, a premier event designed to bring together industry leaders, <mark>기업가</mark>, and professionals to explore the <mark>최신</mark> trends in business strategy, digital transformation, and leadership development.

Event Details:
✔ Date: April 25–26, 2025
✔ Location: Grand Summit Convention Center, San Francisco, CA
✔ Theme: "Innovate, Transform, Succeed – The Future of Business"


Keynote Speakers:
✔ Dr. Michael Roberts – CEO, Global Tech Solutions
✔ Ms. Emily Carter – <mark>저명한</mark> Business Strategist & Author
✔ Mr. Jonathan Park – Chief Digital Officer, Horizon Innovations


Registration Information:
✔ Early Bird Discount: $250 (Register by March 31, 2025)
✔ Standard Registration Fee: $350 (After March 31, 2025)
✔ Group Discount: 10% off for groups of 5 or more

Register Now: Visit www.horizonconference2025.com to secure your spot.

Why Attend?
✔ Gain valuable insights from industry experts
✔ Participate in <mark>상호작용하는</mark> workshops and panel discussions
✔ Expand your professional network with global business leaders

For any inquiries regarding the conference or registration, please contact our Event Coordinator, Lisa Adams, at events@horizoncompany.com.

We look forward to welcoming you to this exclusive event!

Best regards,
Daniel Roberts
Conference Director
Horizon Business Events`,

  wordPairs: {
    entrepreneurs: "기업가",
    latest: "최신",
    Renowned: "저명한",
    interactive: "상호작용하는",
  },

  questions: [],
};

const email15 = {
  id: 15,
  passage: `Subject: Important Update – Event Rescheduling Notice
Dear Attendees,

We regret to inform you that due to <mark>unforeseen</mark> circumstances, the Annual Business Innovation <mark>Summit</mark> 2025, originally scheduled for March 10, 2025, has been rescheduled to a later date. We sincerely apologize for any inconvenience this may cause and appreciate your understanding.

✔ Updated Event Details:
✔ New Date: April 15, 2025
✔ Time: 9:00 AM – 5:00 PM
✔ New Venue: Grand Summit Convention Center, New York, NY

Options for Registered Attendees:
1. Automatic Registration Transfer – If you are available on the new date, your registration will automatically be transferred at no additional cost. No further action is required.
2. Request for Refund – If you are unable to attend on the rescheduled date, you may request a full refund by contacting our support team at events@horizoncompany.com no later than March 25, 2025.

Additional Information:
If you have hotel reservations through our event partner, please contact them directly to modify your booking.
We will provide an updated <mark>agenda</mark> and speaker list closer to the event date.

If you have any further inquiries, feel free to reach out to our Event Coordination Team.

Once again, we appreciate your patience and hope to see you at the summit in April. Thank you for your continued support!

Best regards,
Daniel Roberts
Event Coordinator
Horizon Solutions`,

  translation: `제목: 중요 업데이트 - 행사 일정 변경 안내
참석자 여러분께,

예기치 않은 상황으로 인해 2025년 3월 10일로 예정되었던 연례 비즈니스 혁신 서밋이 추후 날짜로 변경되었음을 알려드립니다. 이로 인한 불편에 대해 진심으로 사과드리며 양해 부탁드립니다.

✔ 변경된 행사 세부사항:
✔ 새로운 날짜: 2025년 4월 15일
✔ 시간: 오전 9시 - 오후 5시
✔ 새로운 장소: 그랜드 서밋 컨벤션 센터, 뉴욕

등록된 참석자를 위한 옵션:
1. 자동 등록 이전 - 새로운 날짜에 참석 가능하신 경우, 추가 비용 없이 등록이 자동으로 이전됩니다. 추가 조치가 필요하지 않습니다.
2. 환불 요청 - 변경된 날짜에 참석이 불가능하신 경우, 2025년 3월 25일까지 events@horizoncompany.com으로 고객 지원팀에 연락하여 전액 환불을 요청하실 수 있습니다.

추가 정보:
행사 파트너사를 통해 호텔을 예약하신 경우, 직접 연락하여 예약을 변경해 주시기 바랍니다.
행사 날짜가 가까워지면 업데이트된 일정과 연사 명단을 제공해 드리겠습니다.

추가 문의사항이 있으시면 행사 조정팀에 연락해 주시기 바랍니다.
다시 한 번 양해해 주셔서 감사드리며, 4월에 서밋에서 뵙기를 희망합니다. 지속적인 지원에 감사드립니다!

감사합니다.
대니얼 로버츠
행사 조정자
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Important Update – Event Rescheduling Notice
Dear Attendees,

We regret to inform you that due to <mark>예기치 않은</mark> circumstances, the Annual Business Innovation <mark>공식회의</mark> 2025, originally scheduled for March 10, 2025, has been rescheduled to a later date. We sincerely apologize for any inconvenience this may cause and appreciate your understanding.

✔ Updated Event Details:
✔ New Date: April 15, 2025
✔ Time: 9:00 AM – 5:00 PM
✔ New Venue: Grand Summit Convention Center, New York, NY

Options for Registered Attendees:
1. Automatic Registration Transfer – If you are available on the new date, your registration will automatically be transferred at no additional cost. No further action is required.
2. Request for Refund – If you are unable to attend on the rescheduled date, you may request a full refund by contacting our support team at events@horizoncompany.com no later than March 25, 2025.

Additional Information:
If you have hotel reservations through our event partner, please contact them directly to modify your booking.
We will provide an updated <mark>일정</mark> and speaker list closer to the event date.

If you have any further inquiries, feel free to reach out to our Event Coordination Team.

Once again, we appreciate your patience and hope to see you at the summit in April. Thank you for your continued support!

Best regards,
Daniel Roberts
Event Coordinator
Horizon Solutions`,

  wordPairs: {
    unforeseen: "예기치 않은",
    Summit: "공식회의",
    agenda: "일정",
  },

  questions: [],
};

export const eventEmailQuestions = [
  email1,
  email2,
  email3,
  email4,
  email5,
  email6,
  email7,
  email8,
  email9,
  email10,
  email11,
  email12,
  email13,
  email14,
  email15,
];
